export const packageKeys = ['cancoat-evo-1-year', 'flash-evo-3-year', 'infinite-evo-5-year'] as const

export type PackageKey = typeof packageKeys[number]

export const packageCatalogue = [
  {
    packageKey: 'cancoat-evo-1-year',
    slug: '1-year-protection',
    displayName: '1 Year Protection',
    productName: 'GYEON Q² CanCoat EVO',
    description:
      'An excellent introduction to ceramic protection, ideal for daily-driven vehicles looking for enhanced gloss, easier maintenance and lasting protection.',
    durabilityLabel: '12 Months+',
    startingPriceCents: 82500,
    currency: 'AUD',
    badge: 'Entry Protection',
    warrantyEligible: false,
    warrantyLabel: null,
    optionalUpgrade: null,
    featured: false,
    active: true,
    estimatedDuration: '1 day',
  },
  {
    packageKey: 'flash-evo-3-year',
    slug: '3-year-protection',
    displayName: '3 Year Protection',
    productName: 'GYEON Q² Flash EVO',
    description:
      'A premium ceramic coating offering enhanced durability, exceptional gloss and long-term protection for vehicles that deserve more.',
    durabilityLabel: '3 Years+',
    startingPriceCents: 115000,
    currency: 'AUD',
    badge: 'Most Popular',
    warrantyEligible: true,
    warrantyLabel: 'Manufacturer-Backed Warranty Available',
    optionalUpgrade: null,
    featured: true,
    active: true,
    estimatedDuration: '1-2 days',
  },
  {
    packageKey: 'infinite-evo-5-year',
    slug: '5-year-protection',
    displayName: '5 Year Protection',
    productName: 'GYEON Q² Infinite EVO',
    description:
      'Our ultimate ceramic coating, delivering outstanding durability, exceptional gloss and the highest level of long-term paint protection.',
    durabilityLabel: '5 Years+',
    startingPriceCents: 165000,
    currency: 'AUD',
    badge: 'Ultimate Protection',
    warrantyEligible: true,
    warrantyLabel: 'Manufacturer-Backed Warranty Available',
    optionalUpgrade: 'Optional GYEON Infinite Top Coat Upgrade',
    featured: false,
    active: true,
    estimatedDuration: '2-3 days',
  },
] as const

export const vehicleTypeOptions = [
  'Car',
  'SUV / 4WD',
  'Ute',
  'Van / Commercial Vehicle',
  'Caravan',
  'Motorbike',
  'Other',
] as const

export const manualConfirmationVehicleTypes = new Set<string>([
  'Van / Commercial Vehicle',
  'Caravan',
  'Motorbike',
  'Other',
])

export const scheduleTimes = ['08:00 AM', '10:30 AM', '01:00 PM', '03:30 PM'] as const

export const protectionAddOnKeys = [
  'glass-protection',
  'wheel-protection',
  'exterior-trim-protection',
  'interior-protection',
] as const

export const detailingInterestKeys = [
  'exterior-detailing',
  'premium-detailing',
  'interior-detailing',
  'paint-enhancement',
  'paint-correction',
  'paint-protection',
  'unsure',
] as const

export const protectionAddOnLabels: Record<string, string> = {
  'glass-protection': 'Glass Protection',
  'wheel-protection': 'Wheel Protection',
  'exterior-trim-protection': 'Exterior Trim Protection',
  'interior-protection': 'Interior Protection',
}

export const detailingInterestLabels: Record<string, string> = {
  'exterior-detailing': 'Exterior Detailing',
  'premium-detailing': 'Premium Detailing & Enhancement',
  'interior-detailing': 'Interior Detailing',
  'paint-enhancement': 'Paint Enhancement',
  'paint-correction': 'Paint Correction',
  'paint-protection': 'Paint Protection',
  unsure: 'Not sure — recommend what my vehicle needs',
}

/** Fixed booking deposit charged at Stripe Checkout. Never derived from package price. */
export const CERAMIC_BOOKING_DEPOSIT_CENTS = 10000
export const BOOKING_DEPOSIT_CURRENCY = 'AUD'

export function getCataloguePackage(packageKey?: string) {
  return packageCatalogue.find((item) => item.packageKey === packageKey)
    ?? packageCatalogue.find((item) => item.featured)
    ?? packageCatalogue[0]
}

export function getConfiguredDepositCents() {
  return CERAMIC_BOOKING_DEPOSIT_CENTS
}
